import {Injectable} from "@angular/core";

@Injectable()
export class ExpandedFoldersService {
  private readonly EXPANDED_FOLDERS = 'expanded-folders';
  private readonly EXPAND_ARTISTS  = 'expand-artists';
  private readonly EXPAND_ALBUMS  = 'expand-albums';

  getExpandedFolders(): number[] {
    return JSON.parse(localStorage.getItem(this.EXPANDED_FOLDERS));
  }

  setExpandedFolders(expandedFolders: number[]) {
    localStorage.setItem(this.EXPANDED_FOLDERS, JSON.stringify(expandedFolders));
  }

  addFolderToExpand(folderId: number) {
    if (!this.expandedFolderContains(folderId)) {
      let expandedFolders = this.getExpandedFolders();
      expandedFolders.push(folderId);
      this.setExpandedFolders(expandedFolders);
    }
  }

  getExpandArtists(): boolean {
    return localStorage.getItem(this.EXPAND_ARTISTS) === 'true';
  }

  setExpandArtists(expand: boolean) {
    localStorage.setItem(this.EXPAND_ARTISTS, expand.toString());
  }

  getExpandAlbums(): boolean {
    return localStorage.getItem(this.EXPAND_ALBUMS) === 'true';
  }

  setExpandAlbums(expand: boolean) {
    localStorage.setItem(this.EXPAND_ALBUMS, expand.toString());
  }

  expandedFolderContains(folderId: number): boolean {
    return JSON.parse(localStorage.getItem(this.EXPANDED_FOLDERS)).includes(folderId);
  }
}
